"use client";

import { useLinkStatus } from "next/link";

/**
 * 顶部导航进度条：软导航 pending 时显示一条细进度条。
 * 替代整页骨架屏（原 app/loading.tsx 已移除）——路由数据就绪前保留当前页面内容，
 * 只在顶部给一个轻量反馈，避免"点目录像跳了页面"的整页闪烁。
 */
export default function NavProgress() {
  const { pending } = useLinkStatus();
  if (!pending) return null;
  return (
    <div
      className="pointer-events-none fixed inset-x-0 top-0 z-[60] h-0.5 overflow-hidden"
      aria-hidden="true"
    >
      <div className="h-full w-1/3 rounded-full bg-primary animate-[navprogress_1.1s_ease-in-out_infinite]" />
    </div>
  );
}
